// Español — traducciones profesionales, formales (usted).
const es = {
  translation: {
    nav: {
      profile: "Perfil",
      dashboard: "Panel",
      analytics: "Analíticas",
      wallet: "Mi Billetera",
      send_topup: "Enviar Recarga",
      gift_cards: "Tarjetas Regalo",
      pay_bills: "Servicios y Facturas",
      agents: "Mis Agentes",
      subagent_tx: "Transacciones de Subagentes",
      master_agents: "Master Agents",
      set_commissions: "Configurar Comisiones",
      my_commissions: "Mis Comisiones",
      master_commissions: "Comisiones de Master",
      master_payouts: "Pagos",
      transfer_funds: "Transferir Fondos",
      reports: "Reportes",
      settings: "Moneda Local",
      make_payment: "Realizar Pago",
      send_cash: "Enviar Efectivo",
      cash_verification: "Verificación de Efectivo",
      exchange_rates: "Tasas y Cargos",
      branding_settings: "Branding Settings",
      pending_codes: "Códigos Pendientes",
      sms_diagnostics: "Diagnósticos SMS",
      provider_management: "Gestión de Proveedores",
      pending_password_reset_codes: "Códigos de Restablecimiento Pendientes",
      trusted_devices: "Dispositivos Confiables",
      audit_log: "Registro de Auditoría",
      my_activity: "Mi Actividad",
      section_navigation: "Navegación",
      folder_my_agents: "Mis Agentes",
      folder_master_agents: "Master Agents",
      logout: "Cerrar sesión",
      folder_create_agent: "Crear Agente",
      folder_agent_management: "Gestión de Agentes",
      folder_create_subagent: "Crear Subagente",
      folder_management: "Gestión",
      folder_subagent_tx: "Transacciones de Subagentes",
      folder_subagent_sales: "Ventas de Subagentes",
      folder_gross_sales: "Reporte de Ventas Brutas",
      folder_set_agent_commissions: "Configurar Comisiones",
      folder_network_performance: "Rendimiento de la Red",
      folder_create_master: "Crear Master Agent",
      folder_master_list: "Lista de Master Agents",
      folder_master_commissions: "Comisiones de Master",
      folder_set_master_commissions: "Configurar Comisiones Master",
      folder_master_sales: "Ventas de Master Agents",
      folder_master_tx: "Transacciones de Master Agents",
      folder_commission_reports: "Reportes de Comisiones",
      folder_my_wallet: "Mi Billetera",
      folder_currencies: "Divisas",
      folder_send_external_transfer: "Enviar transferencia externa",
      folder_funding_history: "Historial de fondos",
      signed_in_as: "Conectado como",
      sign_out: "Cerrar sesión",
    },
    role: {
      MASTER_ADMIN: "Master Admin",
      MASTER_AGENT: "Master Agent",
      AGENT: "Agente",
      CASH_VERIFIER: "Verificador de Efectivo",
    },
    auth: {
      brand_tagline: "Plataforma global de reventa de recargas móviles",
      sign_in_title: "Inicie sesión en su cuenta",
      sign_in_sub: "Ingrese sus credenciales para continuar.",
      welcome_back: "¡Bienvenido!",
      username_placeholder: "Ingrese su usuario",
      password_placeholder: "Ingrese su contraseña",
      username: "Usuario",
      username_or_email: "Usuario o correo",
      password: "Contraseña",
      remember_me: "Recordarme",
      sign_in: "Iniciar sesión",
      signing_in: "Iniciando sesión…",
      forgot_password: "¿Olvidó su contraseña?",
      new_here: "¿Es nuevo aquí?",
      create_account: "Crear una cuenta",
      have_account: "¿Ya tiene una cuenta?",
      register_title: "Cree su cuenta",
      register_sub: "Registre una nueva cuenta de revendedor.",
      name: "Nombre",
      last_name: "Apellido",
      email: "Correo electrónico",
      phone: "Teléfono",
      confirm_password: "Confirmar contraseña",
      passwords_dont_match: "Las contraseñas no coinciden.",
      register: "Registrar",
      registering: "Registrando…",
      forgot_title: "¿Olvidó su contraseña?",
      forgot_sub: "Ingrese su correo y le enviaremos un enlace para restablecerla.",
      send_reset_link: "Enviar enlace",
      sending: "Enviando…",
      back_to_login: "Volver al inicio de sesión",
      back_to_landing: "Volver a la página principal",
      reset_title: "Restablecer su contraseña",
      reset_sub: "Elija una nueva contraseña para su cuenta.",
      new_password: "Nueva contraseña",
      reset_password: "Restablecer contraseña",
      resetting: "Restableciendo…",
      reset_success: "Contraseña restablecida. Ya puede iniciar sesión con la nueva.",
      email_sent: "Revise su correo para las instrucciones.",
      two_factor_title: "Ingrese el código de verificación",
      two_factor_sub: "Enviamos un código de 6 dígitos a {{email}}. Expira en {{minutes}} minutos.",
      code: "Código de verificación",
      verify: "Verificar",
      verifying: "Verificando…",
      resend_code: "Reenviar código",
      resend_in: "Reenviar en {{seconds}} s",
      trust_device: "Confiar en este dispositivo (omitir SMS la próxima vez)",
      device_name: "Nombre del dispositivo (opcional)",
      cancel: "Cancelar",
      pw_rule_length: "Al menos 8 caracteres",
      pw_rule_upper: "Una letra mayúscula (A-Z)",
      pw_rule_lower: "Una letra minúscula (a-z)",
      pw_rule_digit: "Un número (0-9)",
      pw_rule_special: "Un carácter especial (!@#$…)",
    },
    pwreset: {
      title: "¿Olvidaste tu contraseña?",
      step1_sub: "Ingresa tu usuario, correo electrónico o número de teléfono registrado. Te enviaremos un código de 6 dígitos por SMS al teléfono registrado.",
      step1_sub_v2: "Ingresa tu correo electrónico registrado o tu número de teléfono móvil registrado. Enviaremos un código de 6 dígitos por SMS al teléfono registrado en tu cuenta.",
      identifier_label: "Usuario, correo o teléfono (E.164)",
      identifier_label_v2: "Correo electrónico o número de teléfono móvil",
      identifier_placeholder_v2: "Ingrese su correo electrónico registrado o su número de teléfono móvil registrado",
      identifier_examples: "Ejemplos: john@example.com  ·  +56961234567",
      identifier_invalid: "Ingresa un correo válido (nombre@ejemplo.com) o un teléfono en formato E.164 (por ejemplo +56961234567).",
      send_sms: "Enviar código de verificación",
      step2_title: "Ingresa el código SMS",
      step2_sub_sent: "Se envió un código de 6 dígitos a",
      step2_sub_expiry: "Expira en 5 minutos.",
      step2_sub_generic: "Si la cuenta existe, se ha enviado un código de 6 dígitos al teléfono registrado. Expira en 5 minutos.",
      step2_generic_v2: "Si la información ingresada es válida, se ha enviado un código de verificación. Expira en 5 minutos.",
      step2_nomatch_hint: "¿No recibes nada? Verifica tu usuario, correo o teléfono (formato E.164 como +56961000199). Si tu cuenta está registrada sin teléfono, contacta a soporte para restablecer tu contraseña.",
      code_label: "Código de 6 dígitos",
      resend_in: "Reenviar en {{s}} s",
      resend_sms: "Reenviar SMS",
      change_identifier: "Usar otra cuenta",
      change_identifier_v2: "Usar otro correo o teléfono",
      verify: "Verificar código",
      invalid_code_generic: "El código ingresado no es válido o ha expirado.",
      step3_title: "Crea una nueva contraseña",
      step3_sub: "La contraseña debe tener al menos 8 caracteres, una letra mayúscula y una minúscula, un número y un carácter especial.",
      step3_sub_v2: "Elige una contraseña segura. Debes cumplir todos los requisitos siguientes.",
      new_password: "Nueva contraseña",
      confirm_password: "Confirma la nueva contraseña",
      pw_rule_length: "Al menos 8 caracteres",
      pw_rule_letter: "Al menos una letra",
      pw_rule_digit: "Al menos un número",
      pw_rule_no_edge_space: "Sin espacios al inicio ni al final",
      updating: "Actualizando…",
      update_password: "Actualizar contraseña",
      reset_password: "Restablecer contraseña",
      mismatch: "Las contraseñas no coinciden.",
      resent: "Nuevo SMS enviado ({{used}}/{{max}})",
      done_title: "Contraseña actualizada",
      done_title_v2: "Contraseña actualizada correctamente",
      done_sub: "Se revocaron todas las sesiones activas y dispositivos de confianza de esta cuenta. Inicia sesión con tu nueva contraseña — se requerirá un nuevo código SMS para este dispositivo.",
      done_sub_v2: "Su contraseña ha sido actualizada exitosamente.",
      back_to_login: "Volver al inicio de sesión",
      step_identify: "Identificar",
      step_verify: "Verificar",
      step_new: "Nueva contraseña",
    },
    dashboard: {
      title: "Panel",
      welcome: "Bienvenido de nuevo",
      today: "Hoy",
      week: "Esta semana",
      month: "Este mes",
      custom: "Rango personalizado",
      range_yesterday: "Ayer",
      range_7d: "Últimos 7 días",
      range_30d: "Últimos 30 días",
      range_last_month: "Mes pasado",
      range_from: "Desde",
      range_to: "Hasta",
      kpi_available_balance: "Saldo disponible",
      kpi_total_sales: "Ventas totales",
      kpi_my_commissions: "Mis comisiones",
      kpi_total_transactions: "Transacciones totales",
      kpi_master_agents: "Master Agents",
      kpi_total_agents: "Total de agentes",
      kpi_network_volume: "Volumen de la red",
      kpi_top_performer: "Mejor rendimiento",
      internal_pool: "Fondo interno",
      lifetime: "Histórico",
      sales_by_master: "Ventas por Master Agent",
      sales_by_agent: "Ventas por subagente",
      col_id: "ID",
      col_created: "Creado",
      col_product: "Producto",
      col_phone: "Teléfono",
      col_amount_paid: "Monto pagado",
      col_customer_receives: "Cliente recibe",
      master_wallet_balance: "Saldo del Master Wallet",
      master_wallet_hint: "Billetera de la plataforma que financia toda la red",
      last_updated: "última actualización",
      add_funds: "Añadir fondos",
      low_balance_warning: "Saldo bajo — por debajo del umbral {{threshold}}. Considere añadir fondos.",
      transactions: "Transacciones",
      funding_history: "Historial de fondos",
      recent_transactions: "Transacciones recientes",
      quick_actions: "Acciones rápidas",
      view_all: "Ver todo",
      no_transactions: "Aún no hay transacciones.",
      pending_topups: "Pendientes",
      successful_topups: "Recargas exitosas",
      failed_topups: "Recargas fallidas",
      sales_today: "Ventas de hoy",
    },
    wallet: {
      title: "Mi Billetera",
      subtitle: "Consulte su saldo, movimientos y historial de fondos.",
      current_balance: "Saldo actual",
      available: "Disponible",
      currency_usd: "USD",
      request_funds: "Solicitar fondos",
      add_funds: "Añadir fondos",
      export: "Exportar",
      transactions_tab: "Movimientos",
      funding_tab: "Historial de fondos",
      col_date: "Fecha",
      col_type: "Tipo",
      col_source: "Categoría",
      col_reference: "Referencia",
      col_amount: "Monto",
      col_balance_after: "Saldo posterior",
      col_notes: "Nota",
      col_status: "Estado",
      no_entries: "Aún no hay movimientos.",
      no_funding: "Aún no hay solicitudes de fondos.",
      loading: "Cargando billetera…",
      status_pending: "Pendiente",
      status_approved: "Aprobado",
      status_rejected: "Rechazado",
      type_credit: "CRÉDITO",
      type_debit: "DÉBITO",
      cat_topup_hold: "Recarga (retención)",
      cat_topup_reversal: "Reversa de recarga",
      cat_topup_trueup: "Ajuste de recarga",
      cat_commission: "Comisión",
      cat_master_commission_payout: "Comisión semanal Master Agent",
      cat_master_commission_reversal: "Reversa de comisión Master Agent",
      cat_transfer_in: "Transferencia recibida",
      cat_transfer_out: "Transferencia enviada",
      cat_funding: "Ingreso de fondos",
      cat_funding_payku: "Fondos vía Payku",
      cat_funding_manual: "Fondos manuales",
      cat_funding_card: "Fondos con tarjeta",
    },
    topup: {
      title: "Enviar Recarga",
      subtitle: "Envíe crédito móvil a cualquier operador compatible en todo el mundo.",
      country: "País",
      operator: "Operador",
      product: "Producto",
      phone: "Número telefónico",
      select_country: "Seleccione país",
      select_operator: "Seleccione operador",
      select_product: "Seleccione producto",
      phone_placeholder: "Ingrese el número del destinatario",
      estimate: "Cotizar",
      estimating: "Cotizando…",
      send: "Enviar recarga",
      sending: "Enviando…",
      cost_usd: "Costo (USD)",
      amount_to_send: "Monto a enviar",
      recipient_receives: "El destinatario recibe",
      commission: "Su comisión",
      confirm_title: "Confirmar recarga",
      confirm_sub: "Revise los detalles antes de enviar.",
      confirm_send: "Confirmar y enviar",
      success_title: "¡Recarga enviada!",
      success_sub: "Transacción #{{id}} completada con éxito.",
      failed_title: "Recarga fallida",
      failed_sub: "No se pudo completar la transacción. Su saldo fue reembolsado.",
      no_products: "No hay productos disponibles para el operador seleccionado.",
      insufficient_balance: "Saldo insuficiente en la billetera.",
      recent: "Recargas recientes",
      view_receipt: "Ver recibo",
      print: "Imprimir",
      status_success: "Exitoso",
      status_pending: "Pendiente",
      status_failed: "Fallido",
      status_cancelled: "Cancelado",
      status_hold: "En espera",
    },
    cash: {
      title: "Enviar Efectivo",
      subtitle: "Envíe transferencias en efectivo — retiro en los puntos de agentes.",
      failed_credit: "Error al acreditar la billetera",
      failed_send: "Error al enviar efectivo",
      provide_reject_reason: "Por favor, indique un motivo de rechazo",
      provide_verifier_account: "Ingrese la cuenta verificadora que confirmó esta transacción",
      recipient_name: "Nombre del destinatario",
      recipient_last_name: "Apellido del destinatario",
      recipient_phone: "Teléfono del destinatario",
      recipient_country: "País del destinatario",
      recipient_city: "Ciudad del destinatario",
      amount_usd: "Monto (USD)",
      note: "Nota (opcional)",
      review: "Revisar",
      send_cash: "Enviar efectivo",
      sending: "Enviando…",
      confirm_title: "Confirmar transferencia",
      confirm_sub: "Revise los detalles antes de enviar.",
      confirm_send: "Confirmar y enviar",
      success_title: "Transferencia creada",
      success_sub: "Código de retiro: {{code}}",
      insufficient_balance: "Saldo insuficiente.",
      recent: "Transferencias recientes",
      col_recipient: "Destinatario",
      col_amount: "Monto",
      col_status: "Estado",
      col_created: "Creado",
      col_pickup_code: "Código de retiro",
      status_pending: "Pendiente",
      status_completed: "Completada",
      status_cancelled: "Cancelada",
    },
    profile: {
      title: "Perfil",
      subtitle: "Administre su información personal, seguridad y preferencias.",
      tab_personal: "Información personal",
      tab_password: "Contraseña",
      tab_preferences: "Preferencias",
      tab_billing: "Información de facturación",
      account_number: "Número de cuenta",
      name: "Nombre",
      last_name: "Apellido",
      email: "Correo",
      phone: "Teléfono",
      state: "Estado / Región",
      city: "Ciudad",
      address: "Dirección",
      save: "Guardar cambios",
      saving: "Guardando…",
      saved: "Perfil guardado",
      current_password: "Contraseña actual",
      new_password: "Nueva contraseña",
      confirm_password: "Confirmar contraseña",
      change_password: "Cambiar contraseña",
      changing_password: "Cambiando contraseña…",
      password_changed: "Contraseña cambiada con éxito.",
      password_changed_signout: "Contraseña actualizada. Se cerraron todas las sesiones y dispositivos de confianza — inicie sesión nuevamente con su nueva contraseña.",
      passwords_dont_match: "Las contraseñas no coinciden.",
      pw_rule_length: "Al menos 8 caracteres",
      pw_rule_letter: "Al menos una letra",
      pw_rule_digit: "Al menos un número",
      pw_rule_no_edge_space: "Sin espacios al inicio ni al final",
      pw_same_as_current: "La nueva contraseña debe ser diferente de la actual.",
    },
    settings: {
      title: "Moneda local",
      subtitle: "Configure cómo se muestran los montos a usted y a sus clientes.",
      currency: "Moneda",
      exchange_rate: "Tipo de cambio (1 USD =)",
      save: "Guardar",
      saved: "Configuración guardada",
      preferences: "Preferencias",
      language: "Idioma de la interfaz",
      language_hint: "Los cambios se aplican de inmediato en toda la aplicación.",
    },
    commissions: {
      title: "Configurar Comisiones",
      title_master: "Configurar Comisiones de Master Agents",
      title_agent: "Configurar Comisiones de Agentes",
      subtitle: "Configure manualmente el porcentaje de comisión que gana cada agente por operador. Aplica a cada recarga u operación en efectivo con ese operador.",
      subtitle_master: "Configure los porcentajes de comisión por operador para Master Agents. Aquí no se muestran los agentes.",
      subtitle_agent: "Configure los porcentajes de comisión por operador para Agentes. Aquí no se muestran los Master Agents.",
      col_master_commission: "Comisión Master",
      col_agent_commission: "Comisión del Agente (%)",
      you_keep: "Se queda con {{pct}}%",
      pick_agent: "Seleccione un agente",
      no_agents: "Aún no tiene agentes para configurar.",
      search_products: "Buscar productos…",
      country: "País",
      operator: "Operador",
      all: "Todos",
      col_product: "Producto",
      col_ding_pct: "% Ding",
      col_parent_pct: "Disponible para usted",
      col_allocated_pct: "Asignado",
      col_remaining_pct: "Restante",
      col_shared_pct: "Ya compartido",
      save: "Guardar",
      saved: "Comisión actualizada",
      invalid_over: "No puede exceder el % disponible",
      invalid_under: "No puede ser menor al % ya compartido",
      empty: "Ningún producto coincide con los filtros.",
      hierarchy_master: "Master Admin asigna desde Ding; usted asigna desde lo que recibe.",
      hierarchy_admin: "Usted asigna a Master Agents. Ellos distribuyen a sus propios agentes.",
      showing: "Mostrando {{count}} productos",
    },
    transfer: {
      title: "Transferir Fondos",
      subtitle: "Mueva fondos entre su master wallet y sus agentes.",
      master_balance: "Saldo del Master",
      available_to_transfer: "Disponible para transferir",
      select_recipient: "Seleccione destinatario",
      recent_title: "Transferencias recientes",
      audit_hint: "Registro de auditoría de todos los movimientos",
      withdraw_out: "Retiro saliente",
      withdraw_in: "Retiro entrante",
    },
    agents: {
      title: "Gestión de Agentes",
      subtitle: "Cree, edite y administre los agentes de su red.",
      create: "Crear Agente",
      edit: "Editar Agente",
      col_username: "Usuario",
      col_name: "Nombre",
      col_email: "Correo",
      col_phone: "Teléfono",
      col_balance: "Saldo",
      col_status: "Estado",
      col_commission: "Comisión %",
      col_created: "Creado",
      col_actions: "Acciones",
      active: "Activo",
      inactive: "Inactivo",
      activate: "Activar",
      deactivate: "Desactivar",
      no_agents: "Aún no hay agentes. Cree el primero para comenzar.",
      created: "Agente creado",
      updated: "Agente actualizado",
      deactivated: "Agente desactivado",
      activated: "Agente activado",
    },
    masters: {
      title: "Master Agents",
      subtitle: "Revendedores principales de su red.",
      create: "Crear Master Agent",
      col_username: "Usuario",
      col_name: "Nombre",
      col_email: "Correo",
      col_phone: "Teléfono",
      col_balance: "Saldo",
      col_agents: "Agentes",
      col_status: "Estado",
      col_created: "Creado",
      col_actions: "Acciones",
      no_masters: "Aún no hay master agents.",
      created: "Master agent creado",
      updated: "Master agent actualizado",
    },
    sub_tx: {
      title: "Transacciones de Subagentes",
      subtitle: "Cada recarga enviada por los agentes de su red.",
      col_agent: "Agente",
      col_product: "Producto",
      col_phone: "Teléfono",
      col_amount: "Monto",
      col_status: "Estado",
      col_created: "Creado",
      no_tx: "No hay transacciones en el rango seleccionado.",
    },
    analytics: {
      title: "Analíticas",
      subtitle: "Tendencias, mejores rendimientos y salud de la red.",
      kpi_period_sales: "Ventas del período",
      kpi_period_topups: "Recargas del período",
      kpi_avg_ticket: "Ticket promedio",
      kpi_success_rate: "Tasa de éxito",
      top_agents: "Mejores agentes",
      top_operators: "Mejores operadores",
      top_countries: "Mejores países",
      no_data: "No hay datos en el período seleccionado.",
      crunching: "Procesando números…",
      export_failed: "Error al exportar",
      kpi_total_revenue: "Ingresos totales",
      kpi_send_topups: "Recargas enviadas",
      kpi_send_cash: "Envíos de efectivo",
      kpi_wallet_funded: "Billetera fondeada",
      kpi_conv_fees: "Cargos conv.",
      agent_profit_margin: "Margen de ganancia del agente",
      kpi_total_agents: "Total de agentes",
      kpi_master_agents: "Master Agents",
      kpi_active_users: "Usuarios activos",
      inactive: "inactivos",
      kpi_pending_cash: "Efectivo pendiente",
      kpi_completed: "Completado",
      kpi_failed: "Fallido",
      financial_stats: "Estadísticas financieras",
      total_profit: "Ganancia total",
      total_commission: "Comisión total",
      convenience_fees: "Cargos por conveniencia",
      topup_wallet_balance: "Saldo billetera recargas",
      money_sent_topup: "Dinero enviado (Recargas)",
      money_sent_cash: "Dinero enviado (Efectivo)",
      cash_balances: "Saldos en efectivo",
      chart_sales_by_service: "Ventas por servicio",
      chart_topup_vs_cash: "Recargas vs Efectivo",
      chart_daily_revenue: "Ingresos diarios",
      chart_daily_sub: "Recargas + Efectivo (USD equivalentes)",
      chart_top_countries: "Mejores países",
      chart_top_countries_sub: "Ventas por destino (Recargas)",
      chart_sales_by_provider: "Ventas por proveedor",
      chart_sales_by_provider_sub: "Proveedores + MonCash/NatCash",
      chart_cash_by_ccy: "Envíos de efectivo por moneda",
      chart_cash_by_ccy_sub: "Monto base + HTG recibidos",
      chart_funding_by_method: "Fondeo por método de pago",
      chart_funding_sub: "Recargas de billetera (EXITOSAS)",
      chart_top_10_agents: "Top 10 agentes",
      chart_top_agents_sub: "Mejores vendedores por ingresos (USD)",
      chart_top_10_masters: "Top 10 master agents",
      chart_top_masters_sub: "Ventas de red (USD)",
      legend_send_topup: "Recargas",
      legend_send_cash: "Efectivo",
      legend_total: "Total",
      legend_sales_usd: "Ventas USD",
      legend_sent_base: "Enviado (base)",
      legend_received_htg: "Recibido (HTG)",
    },
    audit: {
      title: "Registro de Auditoría",
      title_activity: "Mi Actividad",
      subtitle: "Cada acción realizada en la plataforma, para siempre.",
      col_when: "Cuándo",
      col_actor: "Actor",
      col_action: "Acción",
      col_target: "Objetivo",
      col_ip: "IP",
      col_details: "Detalles",
      no_events: "Aún no hay eventos registrados.",
      admin_scope: "Master Admin",
      activity_scope: "Actividad",
      reload: "Recargar",
      search: "Buscar",
      search_ph: "usuario, acción, ref, IP…",
      from: "Desde",
      to: "Hasta",
      role: "Rol",
      action: "Acción",
      all_roles: "Todos los roles",
      all_actions: "Todas las acciones",
      any_status: "Cualquier estado",
      status_success: "EXITOSO",
      status_failed: "FALLIDO",
      clear: "Limpiar",
      apply: "Aplicar",
      col_user: "Usuario",
      col_role: "Rol",
      col_status: "Estado",
      loading_trail: "Cargando registro…",
      no_records: "Ningún registro coincide con sus filtros.",
      records_total: "{{n}} registros · página {{page}} de {{total}}",
      prev: "Ant.",
      next: "Sig.",
      audit_entry: "Entrada de auditoría",
      when: "Cuándo",
      user: "Usuario",
      role_label: "Rol",
      target: "Objetivo",
      status: "Estado",
      reference: "Referencia",
      ip: "IP",
      device_browser: "Dispositivo / Navegador",
      previous: "Anterior",
      new: "Nuevo",
      payload: "Contenido",
      failed_load: "Error al cargar el registro",
    },
    trusted: {
      title: "Dispositivos Confiables",
      subtitle: "Dispositivos que no requieren código 2FA durante los próximos 30 días.",
      col_device: "Dispositivo",
      col_last_used: "Último uso",
      col_ip: "Última IP",
      col_expires: "Expira",
      col_actions: "Acciones",
      revoke: "Revocar",
      revoked: "Dispositivo revocado",
      no_devices: "Aún no hay dispositivos confiables.",
      reload: "Recargar",
      sign_out_everywhere: "Cerrar sesión en todos los dispositivos",
      mobile_devices: "Dispositivos móviles",
      computers: "Computadoras",
      trust_period: "Periodo de confianza",
      days: "días",
      no_trusted_hint: "No tiene dispositivos confiables. Cada nuevo inicio de sesión requerirá un código de verificación por correo.",
      confirm_remove: "¿Eliminar este dispositivo? Deberá verificar por correo la próxima vez que inicie sesión desde él.",
      confirm_force_logout: "¿Revocar TODOS los dispositivos confiables? Cada navegador necesitará una nueva verificación por correo al iniciar sesión.",
      device_removed: "Dispositivo confiable eliminado",
      failed_remove: "Error al eliminar",
      failed_force_logout: "Error al cerrar sesión",
      failed_load: "Error al cargar los dispositivos confiables",
      revoked_n: "Se revocaron {{n}} dispositivo(s)",
      added: "Añadido",
      last_login: "Último inicio",
      trust_expires_in: "La confianza expira en",
      no_ip: "sin ip",
      remove: "Eliminar",
      expired: "expirado",
    },
    rates: {
      title: "Tasas y Cargos",
      subtitle: "Administre las tasas de conversión USD → moneda local.",
      col_currency: "Moneda",
      col_rate: "Tasa (1 USD =)",
      col_updated: "Actualizada",
      col_actions: "Acciones",
      add: "Añadir moneda",
      save: "Guardar",
      saved: "Tasa guardada",
      tab_tiers: "Niveles de Cargo por Conveniencia",
      exchange_rates_htg: "Tasas de cambio → HTG",
      rates_hint: "1 unidad de la moneda listada = N HTG. Se utiliza como fuente única de verdad para cada Envío de Efectivo.",
      reload: "Recargar",
      loading_rates: "Cargando tasas…",
      loading_tiers: "Cargando niveles…",
      unit_htg: "1 {{ccy}} = ? HTG",
      last_updated_by: "Actualizado por {{name}}",
      no_rate_set: "Sin tasa configurada — Enviar Efectivo estará bloqueado para esta moneda",
      failed_load_rates: "Error al cargar las tasas de cambio",
      failed_load_tiers: "Error al cargar los niveles",
      enter_valid_rate: "Ingrese una tasa válida > 0",
      rate_updated: "Tasa {{ccy}} → HTG actualizada a {{n}}",
      save_failed: "Error al guardar",
      tiers_updated: "Niveles de {{ccy}} actualizados ({{n}})",
      tiers_hint_1: "Cada fila define un límite máximo por rango. Un agente puede cobrar cualquier cargo de conveniencia desde",
      tiers_hint_zero: "0",
      tiers_hint_2: "hasta el",
      tiers_hint_max_fee: "Cargo máx.",
      tiers_hint_3: "de la fila que coincida con el monto. Deje",
      tiers_hint_max_amount: "Monto máx.",
      tiers_hint_4: "vacío para \"sin límite superior\".",
      currency_fee_tiers: "Niveles de cargo — {{ccy}}",
      tier_singular: "nivel",
      tier_plural: "niveles",
      add_tier: "Añadir nivel",
      save_changes: "Guardar cambios",
      col_min_amount: "Monto mín. ({{ccy}})",
      col_max_amount: "Monto máx. ({{ccy}})",
      col_max_fee: "Cargo máx. ({{ccy}})",
      no_tiers_for: "Sin niveles configurados — los agentes no pueden cobrar cargo por conveniencia para {{ccy}}.",
      remove_tier: "Eliminar nivel",
    },
    cash_verify: {
      title: "Verificación de Efectivo",
      subtitle: "Apruebe las solicitudes de retiro pendientes.",
      col_agent: "Agente",
      col_amount: "Monto",
      col_reference: "Referencia",
      col_submitted: "Enviado",
      col_actions: "Acciones",
      approve: "Aprobar",
      reject: "Rechazar",
      approved: "Aprobado",
      rejected: "Rechazado",
      no_pending: "No hay solicitudes pendientes.",
      status_pending: "Pendiente",
      status_confirmed: "Confirmado",
      status_rejected: "Rechazado",
      status_all: "Todos",
      provider: "Proveedor",
      status: "Estado",
      back_profile: "← Perfil",
      back_send_cash: "← Volver a Enviar Efectivo",
      failed_load: "Error al cargar",
      wallet_balance: "Saldo de billetera",
      commission_earned: "Comisión ganada",
      commission_rate_hint: "tasa {{pct}}%",
      pending: "Pendiente",
      confirmed: "Confirmado",
      verification_users: "Usuarios de verificación",
      dedicated_hint: "Dos cuentas dedicadas que procesan las solicitudes de Enviar Efectivo para cada proveedor.",
      not_configured: "(sin configurar)",
      verifier_label: "verificador {{provider}}",
      edit: "Editar",
      create: "Crear",
      balance: "Saldo",
      commission: "Comisión",
      earned: "Ganado",
      show_only_verifier: "Mostrar solo el trabajo de este verificador →",
      showing_only_verifier: "✓ Mostrando solo el trabajo de este verificador",
    },
    pending_codes: {
      title: "Códigos Pendientes",
      subtitle: "Códigos 2FA activos a la espera de ser utilizados.",
      col_user: "Usuario",
      col_role: "Rol",
      col_code: "Código",
      col_expires: "Expira",
      no_codes: "No hay códigos pendientes.",
      breadcrumb: "Seguridad · Soporte",
      long_subtitle: "Códigos activos de verificación por correo en espera — tanto para Agentes como Master Agents. Solo visibles para Master Admin y Master Agents. Cada lectura se registra en el Registro de Auditoría.",
      reload: "Recargar",
      filter_all: "Todos",
      filter_masters: "Master Agents",
      filter_agents: "Agentes",
      filter_verifiers: "Usuarios de verificación",
      filter_moncash: "Verificador MonCash",
      filter_natcash: "Verificador NatCash",
      col_username: "Usuario",
      col_email: "Correo",
      col_created: "Creado",
      col_status: "Estado",
      loading: "Cargando…",
      no_active: "No hay códigos activos. Cuando un usuario solicite uno, aparecerá aquí por 5 minutos.",
      min_left: "{{n}} min restantes",
      copy_code: "Copiar código",
      code_copied: "Código copiado al portapapeles",
      failed_load: "Error al cargar los códigos pendientes",
      escalation_path: "Ruta de escalado:",
      escalation_text: "Si un agente no recibe su código, contacta a su Master Agent. Si el Master Agent no puede resolverlo, contacta al Master Admin.",
    },
    // Cadenas compartidas de UI — utilizadas en varias páginas/componentes.
    my_commissions: {
      title: "Mis Comisiones",
      subtitle: "El porcentaje de comisión asignado por operador. Esta información es solo lectura — contacte a su Master Agent para solicitar cambios.",
      operators: "Operadores",
      with_commission: "Con comisión",
      no_commission: "Sin comisión",
      search_operators: "Buscar operadores…",
      country: "País",
      country_all: "Todos",
      only_assigned: "Mostrar solo operadores con comisión",
      col_id: "ID",
      col_product: "Producto",
      col_country_operator: "País / Operador",
      col_commission: "Comisión",
      col_status: "Estado",
      cash_badge: "efectivo",
      no_assigned_yet: "Aún no tiene comisiones asignadas. Contacte a su Master Agent.",
      no_match: "Ningún operador coincide con sus filtros.",
    },
    reports: {
      tab_charts: "Gráficos",
      tab_sales: "Ventas por estado",
      tab_master_agents: "Por master agent",
      tab_agents: "Por agente",
      tab_operators: "Por operador",
      tab_countries: "Por país",
      tab_commissions: "Comisiones",
      tab_search: "Buscar transacciones",
      range_all: "Todo el tiempo",
      range_today: "Hoy",
      range_yesterday: "Ayer",
      range_7d: "Últimos 7 días",
      range_30d: "Últimos 30 días",
      range_month: "Este mes",
      range_last_month: "Mes pasado",
      range_custom: "Rango personalizado",
      loading: "Cargando…",
      no_data: "Sin datos para este reporte.",
      col_status: "Estado",
      col_count: "Cantidad",
      col_total: "Total",
      col_commission: "Comisión",
      col_id: "ID",
      col_master_agent: "Master agent",
      col_agents_count: "Agentes",
      col_topups: "Recargas",
      col_network_sales: "Ventas de red",
      col_commissions_paid: "Comisiones pagadas",
      col_agent: "Agente",
      col_total_sales: "Ventas totales",
      col_operator: "Operador",
      col_country: "País",
      no_data_short: "Sin datos.",
      search_by_phone: "Buscar por número de teléfono (completo o parcial, ej. 5093 o 50937188551)",
      kpi_available_balance: "Saldo disponible",
      kpi_total_sales: "Ventas totales",
      kpi_my_commissions: "Mis comisiones",
      kpi_total_transactions: "Total de transacciones",
      showing_data: "Mostrando datos de",
      chart_sales_earnings_month: "Ventas y ganancias por mes",
      last_6_months: "Últimos 6 meses",
      chart_sales_by_products: "Ventas por producto",
      top_operators_range: "Top 6 operadores · rango seleccionado",
      chart_sales_by_week: "Ventas por semana",
      chart_sales_by_master: "Ventas por Master Agent",
      top_8_range: "Top 8 · rango seleccionado",
      chart_payments_debits: "Ingresos vs Egresos",
      wallet_movements: "Movimientos de billetera en el rango",
      last_8_weeks: "Últimas 8 semanas",
      payments_in: "Ingresos",
      debits_out: "Egresos",
      no_data_range: "Sin datos para el rango seleccionado.",
      lifetime_earnings: "Sus ganancias de comisión totales",
      total_earned: "Total ganado",
      no_commission_earnings: "Aún no hay comisiones ganadas.",
      no_transactions_for: "No se encontraron transacciones para \"{{phone}}\".",
      customer_paid: "Cliente pagó",
      usd_internal: "USD (interno)",
      rate: "Tasa",
      legend_sales: "Ventas",
      legend_earnings: "Ganancias",
      export_master_csv: "CSV Master Agent",
      export_agent_csv: "CSV Agente",
      export_operator_csv: "CSV Operador",
      export_country_csv: "CSV País",
    },
    send_cash: {
      switch_to_topup: "Cambiar a Enviar Recarga",
      wallets_all: "Billeteras Enviar Efectivo · todas las monedas",
      wallet_balance_label: "Saldo Enviar Efectivo",
      wallet_hint: "Este saldo se usa solo para Enviar Efectivo (MonCash / NatCash). Es independiente de su billetera Enviar Recarga.",
      transfer_cash_agent: "Transferir Efectivo a un agente",
      open_cash_verification: "Abrir Verificación de Efectivo",
      full_name_required: "Nombre completo *",
      full_name_hint: "Ingrese el nombre completo del destinatario exactamente como aparece en su cuenta de MonCash / NatCash.",
      recipient_phone_required: "Teléfono del destinatario *",
      haiti_prefix: "Haití · +509",
      haiti_country_code: "Código de país Haití",
      phone_hint: "El código de país +509 se aplica para Haití. Ingrese el número local de 8 dígitos.",
      detected: "Detectado",
      admin_override: "Anulación de admin:",
      could_not_detect: "No se pudo detectar automáticamente la billetera en Haití. Verifique el número.",
      amount_to_send_ccy: "Monto a enviar ({{ccy}}) *",
      amount_to_send_usd: "Monto a enviar (USD) *",
      convenience_fee_ccy: "Cargo por conveniencia ({{ccy}})",
      convenience_fee_usd: "Cargo por conveniencia (USD)",
      max_fee: "Máx {{n}} USD",
      max_fee_ccy: "Máx {{n}} {{ccy}}",
      exceeds_balance: "Excede su saldo ({{balance}})",
      live_summary: "Resumen en vivo",
      amount_to_send: "Monto a enviar",
      convenience_fee: "Cargo por conveniencia",
      total_to_pay: "Total a pagar",
      receiver_gets: "El destinatario recibe",
      exchange_rate: "Tasa de cambio",
      note_optional_upper: "Nota / referencia (opcional)",
      internal_reference: "Referencia interna mostrada en el recibo",
      only_amount_debited: "Solo este monto se debita de su billetera.",
      profit_kept: "Su ganancia. La conserva usted — nunca se descuenta de la billetera.",
    },
    providers: {
      breadcrumb: "Admin · Gestión de Proveedores",
      title: "Red {{brand}}",
      subtitle: "Detalles internos de los proveedores. Visible solo para el Master Admin — master agents, agentes y clientes nunca ven esta sección.",
      master_only: "Solo Master Admin",
    },
    ui: {
      show: "Mostrar",
      entries: "entradas",
      of: "de",
      page: "Página",
      per_page: "{{n}} / página",
      apply: "Aplicar",
      prev: "Ant.",
      previous: "Anterior",
      next: "Siguiente",
      showing: "Mostrando",
      showing_range: "Mostrando {{from}} – {{to}} de {{total}} {{noun}}",
      network: "Red",
      loading: "Cargando…",
      actions_btn: "Acciones",
      view_sales: "Ver ventas",
      view_agents: "Ver agentes",
      edit_agent: "Editar agente",
      edit_master_agent: "Editar master agent",
      change_password: "Cambiar contraseña",
      transfer_funds_action: "Transferir fondos",
      withdraw_funds_action: "Retirar fondos",
      transfer_cash_action: "Transferir efectivo",
      withdraw_cash_action: "Retirar efectivo",
      set_commissions_action: "Configurar comisiones",
      create_agent_title: "Crear nuevo agente",
      edit_agent_title: "Editar agente",
      create_master_title: "Crear nuevo master agent",
      edit_master_title: "Editar master agent",
      reset_password_title: "Restablecer contraseña — {{username}}",
      transfer_title: "Transferir fondos → {{username}}",
      withdraw_title: "Retirar fondos — {{username}}",
      transfer_cash_title: "Transferir efectivo → {{username}}",
      withdraw_cash_title: "Retirar efectivo — {{username}}",
      sales_modal_title: "Ventas — {{name}} ({{code}})",
      network_sales_modal_title: "Ventas de red — {{name}} ({{code}})",
      full_name: "Nombre completo",
      username: "Usuario",
      email: "Correo",
      phone_number: "Teléfono",
      password: "Contraseña",
      commission_pct: "Comisión %",
      note_optional: "Nota (opcional)",
      internal_reference: "Referencia interna",
      active_label: "Activo",
      assign_master: "Asignar a un master agent",
      keep_under_me: "Mantener a mi cargo ({{admin}})",
      new_password_min: "Nueva contraseña (mínimo 4 caracteres)",
      pw_reset_hint: "El agente deberá usar la nueva contraseña en su próximo inicio de sesión.",
      amount_transfer_usd: "Monto a transferir (USD)",
      amount_withdraw_max: "Monto a retirar (máx. {{max}})",
      amount_in: "Monto en {{currency}}",
      amount_transfer_in: "Monto a transferir en {{currency}}",
      amount_withdraw_in: "Monto a retirar en {{currency}}",
      currency: "Moneda",
      current_balance: "Saldo actual",
      available: "Disponible",
      current: "Actual",
      new_agents_hint: "Los nuevos agentes se crean con saldo $0. Puede fondearlos luego desde Transferir Fondos.",
      new_masters_hint: "Los nuevos master agents inician con saldo $0 y sin subagentes. Puede fondearlos luego mediante Transferir Fondos.",
      cash_wallet_hint: "Billetera de Enviar Efectivo (separada del saldo de recargas)",
      pull_cash_hint: "Retirar el saldo de Enviar Efectivo a su billetera",
      agent_current_balance: "Saldo actual del agente",
      master_topup_balance: "Saldo de recargas del master agent",
      funds_move_master_to_master: "Los fondos se moverán desde su billetera de master admin hacia este master agent.",
      funds_removed_agent_to_master: "Los fondos se retirarán del agente y se acreditarán a su master wallet.",
      funds_removed_master_to_admin: "Los fondos se retirarán del master agent y se acreditarán de vuelta a su billetera Master Admin.",
      search_users: "Buscar ID, nombre, usuario, teléfono, correo…",
      search_tx: "Buscar ID, usuario, teléfono, ID de transacción…",
      agent_created: "Agente creado",
      agent_updated: "Agente actualizado",
      master_created: "Master agent creado",
      master_updated: "Master agent actualizado",
      update_failed: "Error al actualizar",
      create_agent_failed: "Error al crear el agente",
      create_master_failed: "Error al crear el master agent",
      transfer_success: "Se transfirieron {{amount}} a {{username}}",
      withdraw_success: "Se retiraron {{amount}} de {{username}}",
      cash_transfer_success: "Se transfirieron {{amount}} {{currency}} en efectivo a {{username}}",
      cash_withdraw_success: "Se retiraron {{amount}} {{currency}} en efectivo de {{username}}",
      transfer_failed: "Error en la transferencia",
      withdraw_failed: "Error en el retiro",
      cash_transfer_failed: "Error al transferir efectivo",
      cash_withdraw_failed: "Error al retirar efectivo",
      pw_min_4: "La contraseña debe tener al menos 4 caracteres",
      pw_reset_for: "Contraseña restablecida para {{username}}",
      pw_reset_failed: "Error al restablecer",
      enter_valid_amount: "Ingrese un monto válido",
      only_available: "Solo hay {{amount}} {{currency}} disponibles",
      only_master_has: "El master agent solo tiene {{amount}} disponibles",
      only_agent_has: "El agente solo tiene {{amount}} disponibles",
      agent_active: "Agente activado",
      agent_inactive: "Agente desactivado",
      master_active: "Master agent activado",
      master_inactive: "Master agent desactivado",
      could_not_load: "No se pudieron cargar las ventas",
      failed_generic: "Error",
      subagent_scope_agents: "Transacciones de subagentes en el rango seleccionado.",
      subagent_scope_masters: "Transacciones de master agents en el rango seleccionado.",
      export_csv: "Exportar CSV",
      transactions_lower: "transacciones",
      agents_lower: "agentes",
      master_agents_lower: "master agents",
      no_subagent_tx: "No hay transacciones de subagentes en este rango.",
      loading_ellipsis: "Cargando…",
      range_today: "Hoy",
      range_yesterday: "Ayer",
      range_7d: "Últimos 7 días",
      range_30d: "Últimos 30 días",
      range_this_month: "Este mes",
      range_last_month: "Mes pasado",
      range_custom: "Rango personalizado",
      agent_col_agent: "Agente",
      col_transactions: "Transacciones",
      col_commissions: "Comisiones",
      master_agent_label: "Master agent",
      back_to_masters: "Volver a Master Agents",
      clear_filter: "Quitar filtro de master agent",
      no_data: "Sin datos.",
      loading_data: "Cargando datos…",
      created: "Creado",
      updated: "Actualizado",
      notifications: "Notificaciones",
      mark_all_read: "Marcar todo como leído",
      no_notifications: "Aún no hay notificaciones.",
    },
    common: {
      loading: "Cargando…",
      update: "Actualizar",
      save: "Guardar",
      cancel: "Cancelar",
      close: "Cerrar",
      edit: "Editar",
      delete: "Eliminar",
      confirm: "Confirmar",
      refresh: "Actualizar",
      search: "Buscar",
      actions: "Acciones",
      submit: "Enviar",
      back: "Atrás",
      next: "Siguiente",
      previous: "Anterior",
      apply: "Aplicar",
      reset: "Restablecer",
      export: "Exportar",
      print: "Imprimir",
      download: "Descargar",
      copy: "Copiar",
      copied: "Copiado",
      yes: "Sí",
      no: "No",
      required: "Obligatorio",
      optional: "Opcional",
      status: "Estado",
      date: "Fecha",
      amount: "Monto",
      total: "Total",
      details: "Detalles",
      view: "Ver",
      view_details: "Ver detalles",
      loading_more: "Cargando más…",
      no_results: "No se encontraron resultados.",
      error_generic: "Algo salió mal. Inténtelo de nuevo.",
      success_saved: "Guardado con éxito.",
      required_field: "Este campo es obligatorio.",
      invalid_email: "Ingrese un correo válido.",
      invalid_phone: "Ingrese un número de teléfono válido.",
      min_password: "La contraseña debe tener al menos 6 caracteres.",
    },
    change_role: {
      menu_item: "Cambiar rol / Reasignar",
      section_label: "Control de administrador",
      title: "Cambiar rol de {{username}}",
      loading: "Cargando información actual…",
      current_role: "Rol actual",
      current_parent: "Jefe actual",
      wallet_balance: "Billetera USD",
      history_count: "Recargas · comisiones",
      history_hint: "Todo el historial permanece vinculado",
      new_role: "Nuevo rol",
      new_parent_admin: "Nuevo jefe (Master Admin)",
      new_parent_master: "Nuevo jefe — elija un Master Admin o Master Agent",
      parent_admin: "Master Admin",
      parent_none_admin: "Sin jefe (tope de la jerarquía)",
      pick_parent: "Elija el nuevo jefe…",
      impact_title: "Vista previa del impacto",
      parent_label: "Jefe",
      impact_history: "Saldo de billetera, libro mayor, recargas, comisiones, recibos y auditoría se conservan.",
      impact_wallet: "Los saldos de billetera y Enviar Efectivo no se modifican.",
      impact_permissions: "Los permisos de acceso se actualizarán en el próximo inicio de sesión.",
      impact_master_perms_removed: "Se revocarán los permisos de Master Agent. Ya no podrá gestionar agentes.",
      impact_master_perms_granted: "Se otorgarán permisos de Master Agent. Podrá crear y gestionar sus propios agentes.",
      downgrade_title: "{{count}} agentes dependen actualmente de este master",
      downgrade_hint: "Elija a dónde se reasignarán esos agentes antes de degradar a este usuario.",
      dg_move_admin: "Mover todos sus agentes bajo Master Admin",
      dg_move_master: "Mover todos sus agentes a otro Master Agent",
      dg_block: "Bloquear el cambio hasta que no tenga agentes",
      pick_downgrade: "Elija cómo manejar los sub-agentes.",
      pick_downgrade_target: "Elija el Master Agent de destino.",
      admin_warn_title: "Promoción a Master Admin",
      admin_warn_hint: "Esto otorga control total de la plataforma. Hágalo solo si realmente desea compartir el rol de administrador único.",
      admin_warn_confirm: "Entiendo que este usuario tendrá acceso administrativo completo.",
      confirm_admin_first: "Primero confirme la promoción a Master Admin.",
      reason: "Motivo (opcional, se guarda en la auditoría)",
      reason_placeholder: "p. ej. Promoción por expansión regional",
      confirm_password: "Su contraseña de administrador",
      password_placeholder: "Escriba su contraseña para confirmar",
      password_required: "Confirme con su contraseña de administrador.",
      apply: "Aplicar cambio de rol",
      saved: "Cambio de rol aplicado. Auditoría actualizada.",
      failed: "No se pudo cambiar el rol.",
      failed_preview: "No se pudieron cargar los datos del usuario.",
    },
    landing: {
      nav_home: "Inicio",
      nav_about: "Acerca de",
      nav_services: "Servicios",
      nav_products: "Productos",
      nav_partners: "Partners",
      nav_contact: "Contacto",
      cta_login: "Iniciar sesión",
      cta_dashboard: "Ir al panel",
      hero_kicker: "Instantáneo · Seguro · Global",
      hero_title: "Conecta el mundo con {{brand}}",
      hero_subtitle: "Una plataforma simple, rápida y segura para recargas móviles internacionales, pagos digitales y gestión de tu red de revendedores.",
      hero_cta_learn: "Explorar servicios",
      hero_trust_secure: "Cifrado de nivel bancario",
      hero_trust_instant: "Liquidación en tiempo real",
      hero_trust_multi: "Red multi-rol",
      promo_text: "",
      about_kicker: "Acerca de",
      about_title: "Diseñado para revendedores, elegido por agentes.",
      about_p1_prefix: "{{brand}} es una plataforma global de recargas diseñada para ",
      about_p1_role1: "master agente",
      about_p1_between: " y ",
      about_p1_role2: "agente de campo",
      about_p1_suffix: ". Te damos la columna operacional — cartera, libro mayor, comprobantes y cumplimiento — para que tú te concentres en atender a tus clientes.",
      about_p1: "{{brand}} es una plataforma global de recargas diseñada para master agente y agente de campo. Te damos la columna operacional — cartera, libro mayor, comprobantes y cumplimiento — para que tú te concentres en atender a tus clientes.",
      about_p2: "Desde operaciones en un solo país hasta redes multi-región, nuestras herramientas escalan contigo: comisiones transparentes, analítica en tiempo real y auditabilidad de nivel empresarial listas para usar.",
      value_secure_title: "Seguro por diseño",
      value_secure_desc: "2FA, dispositivos de confianza, auditoría en cada acción.",
      value_realtime_title: "Tiempo real",
      value_realtime_desc: "Cartera, libro mayor y comprobantes al instante.",
      value_hierarchy_title: "Multi-rol",
      value_hierarchy_desc: "Master agente · Agente · Colaborador.",
      value_global_title: "Global",
      value_global_desc: "Multi-moneda, multi-país, carteras ancladas en USD.",
      value_whitelabel_title: "White Label",
      value_whitelabel_desc: "Marca propia, personalización y experiencia lista para tu negocio.",
      services_kicker: "Servicios",
      services_title: "Todo lo que tu red de reventa necesita.",
      services_sub: "Cuatro servicios centrales — una plataforma integrada, una cartera, un panel.",
      svc_giftcards_title: "Tarjetas de regalo",
      svc_giftcards_desc: "Tarjetas de regalo digitales de marcas y plataformas populares, entregadas al instante.",
      svc_topup_title: "Recargas y pago de facturas",
      svc_topup_desc: "Recargas móviles instantáneas y pago de servicios a cientos de operadores en todo el mundo.",
      svc_intl_calls_title: "Llamadas internacionales",
      svc_intl_calls_desc: "Sabemos que los tiempos son difíciles ahora mismo, pero el costo nunca debería impedirte mantener el contacto con tus seres queridos.",
      svc_api_title: "Integración API",
      svc_api_desc: "API REST para empresas y revendedores que quieren integrar recargas, retiros de efectivo y tarjetas de regalo de forma nativa.",
      products_kicker: "Productos",
      products_title: "Dos maneras de gestionar tu negocio.",
      prod_web_title: "Portal Web",
      prod_web_desc: "Panel de revendedor completo: cartera en tiempo real, recargas instantáneas, comisiones transparentes, clientes verificados, comprobantes e informes.",
      prod_web_bullet_0: "Jerarquía multi-rol — Master Agent · Agent · Colaborador",
      prod_web_bullet_1: "Carteras en USD con recarga instantánea",
      prod_web_bullet_2: "Comprobantes PDF e informes con nivel de auditoría",
      prod_web_master_label: "Master Agent",
      prod_web_master_alt: "Vista previa del portal Master Agent",
      prod_web_agent_label: "Agent",
      prod_web_agent_alt: "Vista previa del portal Agent",
      prod_mobile_title: "Aplicación móvil",
      prod_mobile_desc: "Envía recargas, verifica identidades, aprueba retiros y supervisa a tus agentes desde donde estés.",
      prod_mobile_bullet_0: "Experiencia nativa para agentes en movimiento",
      prod_mobile_bullet_1: "Notificaciones push para aprobaciones pendientes",
      prod_mobile_bullet_2: "Comprobantes accesibles sin conexión",
      prod_mobile_coming_soon: "Próximamente",
      prod_mobile_alt: "Vista previa de la futura aplicación móvil My GlobalTopup",
      partners_kicker: "Servicios disponibles",
      partners_title: "Envía recargas a los operadores líderes.",
      partners_sub: "A continuación, una muestra de los operadores disponibles a través de nuestra plataforma. Contacta a nuestro equipo para la lista completa — cientos de redes en decenas de países.",
      partners_disclaimer: "Todas las marcas, nombres comerciales y logotipos mencionados son propiedad de sus respectivos titulares y se muestran únicamente para identificar los servicios disponibles a través de nuestra plataforma.",
      stats_title: "Nosotros hablamos con números",
      stat_operators: "Operadores",
      stat_countries: "Países Disponibles",
      stat_users: "Usuarios en el Mundo",
      stat_support: "Atención al Cliente",
      cta_title: "¿Listo para empezar a revender?",
      cta_sub: "Inicia sesión en tu cuenta o contacta a nuestro equipo para convertirte en partner.",
      cta_whatsapp: "Chatear por WhatsApp",
      cta_email_label: "Enviar correo",
      contact_form: {
        title: "Contactar a My GlobalTopup",
        subtitle: "Envíanos un mensaje y nuestro equipo te responderá lo antes posible.",
        field_name: "Nombre completo",
        field_email: "Correo electrónico",
        field_phone: "Teléfono móvil (opcional)",
        field_subject: "Asunto (opcional)",
        field_message: "Mensaje",
        hint_phone: "Formato internacional, por ejemplo +56961234567",
        ph_name: "Ej.: Juan Pérez",
        ph_subject: "¿En qué podemos ayudarte?",
        ph_message: "Cuéntanos brevemente sobre tu negocio y cómo podemos ayudarte.",
        err_name: "Ingresa tu nombre completo.",
        err_email: "Ingresa un correo electrónico válido.",
        err_phone: "Usa formato internacional (ej.: +56961234567).",
        err_message: "Escribe un mensaje breve (mínimo 5 caracteres).",
        err_message_long: "El mensaje es demasiado largo (máximo 2000 caracteres).",
        err_send: "No pudimos entregar tu mensaje. Inténtalo de nuevo pronto.",
        cancel: "Cancelar",
        send: "Enviar mensaje",
        sending: "Enviando…",
        close: "Cerrar",
        done: "Listo",
        success_title: "Mensaje enviado correctamente",
        success_body: "Gracias por contactar a My GlobalTopup. Nuestro equipo responderá lo antes posible.",
      },
      footer_tagline: "Una plataforma simple, rápida y segura para recargas globales y pagos digitales.",
      footer_company: "Empresa",
      footer_services: "Servicios",
      footer_products: "Productos",
      footer_legal: "Legal",
      footer_privacy: "Política de privacidad",
      footer_terms: "Términos y condiciones",
      footer_rights: "Todos los derechos reservados.",
      footer_login: "Iniciar sesión",
      footer_forgot: "Olvidé mi contraseña",
      footer_follow: "Síguenos",
      footer_download: "Descarga la app",
      footer_play_get: "Disponible en",
      legal_back_home: "Volver al inicio",
    },
    branding: {
      stats_section: "Landing page",
      stats_title: "Estadísticas de la Landing Page",
      stats_hint: "Cifras que aparecen en la página pública. Cada estadística permanece oculta hasta que la habilites y le pongas un valor confirmado (ej. «400+», «70+», «24/7»). Todo el bloque se puede desactivar con el interruptor de abajo.",
      stats_section_on: "Sección visible en la página de inicio",
      stats_section_off: "Sección oculta — no se mostrará ninguna estadística",
      stats_label_ph: "Etiqueta (ej. Operadores)",
      stats_value_ph: "Valor (ej. 400+, 24/7)",
      stats_shown: "Visible",
      stats_hidden: "Oculta",
      stats_saved: "Estadísticas de la landing page guardadas",
    },
  },
};

export default es;
